import React, { useRef, useEffect } from "react"
import { RootState, useTypedSelector } from "../app/store"

type TableFilterDropdownProps = {
  options: string[]
  selectedValues: string[]
  onSelect: (value: string) => void
  onClose: () => void
}

const TableFilterDropdown: React.FC<TableFilterDropdownProps> = ({
  options,
  selectedValues,
  onSelect,
  onClose,
}) => {
  const authStore = useTypedSelector((state: RootState) => {
    return state.authSlice
  })
  const dropdownRef = useRef<HTMLDivElement>(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        onClose()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [onClose])

  if (!options || options.length === 0) return null

  return (
    <div
      ref={dropdownRef}
      className="absolute top-full left-0 mt-1 bg-white border border-gray-300 border-solid rounded shadow-lg z-50 min-w-[180px] text-black font-normal">
      <ul className="max-h-60 overflow-y-auto">
        {options.map((option) => (
          <li key={option} className="p-2 cursor-pointer text-sm text-left">
            <label
              className="flex items-center cursor-pointer"
              htmlFor={`filter-${option}`}
              onClick={(e) => {
                e.stopPropagation()
                onSelect(option)
              }}>
              <input
                type="checkbox"
                checked={selectedValues.includes(option)}
                onChange={() => {}}
                onClick={(e) => {
                  e.stopPropagation()
                  onSelect(option)
                }}
                className="relative peer w-4 h-4 shrink-0 text-blue-600 bg-gray-300 rounded-sm focus:ring-blue-500 cursor-pointer checked:bg-blue-300"
              />
              <span className="ml-2 mr-12">{option}</span>
            </label>
          </li>
        ))}
        <div className="flex justify-start">
          {authStore.user.roles[0].name == "Recruiter" ? (
            <div className="w-full flex justify-around mb-2">
              <li
                className="p-1 px-4 cursor-pointer text-sm text-left hover:bg-gray-200 list-none bg-[#3B82F6] text-white rounded-md"
                onClick={(e) => {
                  e.stopPropagation()
                  onSelect("Apply")
                }}>
                Apply
              </li>
              <li
                className="p-1 px-4 cursor-pointer text-sm text-left hover:bg-gray-200 list-none bg-[#3B82F6] text-white rounded-md"
                onClick={(e) => {
                  e.stopPropagation()
                  onSelect("clear_selected")
                }}>
                Clear All
              </li>
            </div>
          ) : (
            <li
              className="p-2 cursor-pointer text-sm text-left hover:bg-gray-200 list-none bg-[#3B82F6] text-white rounded-md"
              onClick={(e) => {
                e.stopPropagation()
                onSelect("clear_selected")
              }}>
              Clear All
            </li>
          )}
        </div>
      </ul>
    </div>
  )
}

export default TableFilterDropdown
